import styled from 'styled-components'

export const ReportWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 2.8rem;
`

export const ReportToolbar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.85rem;
`

export const PrintButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-family: Poppins;
  font-size: 0.86rem;
  font-weight: 600;
  color: #ffffff;
  background: linear-gradient(90deg, #1AA0FF 0%, #166DD8 95.42%);
  border: none;
  border-radius: 10px;
  padding: 0.65rem 1.15rem;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(22, 109, 216, 0.26);
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(22, 109, 216, 0.32);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
    transform: none;
  }
`

export const PrintIcon = styled.span`
  display: flex;
  width: 1rem;
  height: 1rem;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export const Sheet = styled.div`
  background: #ffffff;
  border: 1px solid #e1e7f2;
  border-radius: 16px;
  box-shadow: 0 10px 24px rgba(14, 41, 72, 0.06);
  padding: 2rem 2.2rem 2.3rem;
  box-sizing: border-box;
  font-family: Poppins;

  @media (max-width: 700px) {
    padding: 1.3rem 1.1rem 1.6rem;
  }
`

export const LogoRow = styled.div`
  display: flex;
  align-items: center;
`

export const LogoImg = styled.img`
  width: 8.2rem;
  max-width: 150px;
  height: auto;
`

export const ReportTitle = styled.div`
  text-align: center;
  font-size: 1.2rem;
  font-weight: 700;
  color: #12305c;
  letter-spacing: 0.02em;
  margin-top: 0.8rem;
`

export const ReportSubtitle = styled.div`
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  color: #1a73c7;
  margin-top: 0.35rem;
`

export const TitleRule = styled.div`
  height: 2px;
  background: #1a73c7;
  border-radius: 2px;
  margin: 1rem 0 1.25rem;
`

export const InfoCard = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.85rem 1.4rem;
  background: #f2f5fa;
  border: 1px solid #e2e8f2;
  border-radius: 10px;
  padding: 1rem 1.15rem;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`

export const InfoItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
`

export const InfoIcon = styled.span`
  display: flex;
  flex-shrink: 0;
  width: 1.05rem;
  height: 1.05rem;
  margin-top: 0.1rem;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export const InfoText = styled.div`
  font-size: 0.86rem;
  color: #2b3a52;
  line-height: 1.4;
`

export const InfoStrong = styled.span`
  font-weight: 700;
  color: #12305c;
`

export const SectionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.78rem;
  font-weight: 700;
  color: #1a73c7;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin: 1.5rem 0 0.7rem;
`

export const SectionIcon = styled.span`
  display: flex;
  width: 1rem;
  height: 1rem;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export const SkillsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
`

export const Th = styled.th`
  background: #1c4e9c;
  color: #ffffff;
  font-size: 0.82rem;
  font-weight: 600;
  text-align: ${(props) => props.$align || 'left'};
  padding: 0.6rem 0.85rem;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;

  &:first-child {
    border-radius: 4px 0 0 0;
  }

  &:last-child {
    border-radius: 0 4px 0 0;
  }
`

export const Td = styled.td`
  border: 1px solid #dde4ee;
  padding: 0.5rem 0.85rem;
  font-size: 0.82rem;
  color: #2b3a52;
  vertical-align: middle;
  line-height: 1.35;
`

export const LevelCell = styled(Td)`
  width: 42%;
`

export const LevelInner = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
`

export const LevelBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 1.7rem;
  height: 1.35rem;
  border-radius: 4px;
  background: ${(props) => props.$bg};
  color: ${(props) => props.$fg};
  font-size: 0.8rem;
  font-weight: 700;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
`

export const LevelText = styled.span`
  font-size: 0.8rem;
  color: #3b4a61;
`

export const SynthesisText = styled.p`
  font-size: 0.84rem;
  line-height: 1.65;
  color: #46566f;
  margin: 0;
  text-align: justify;
`

export const StateCard = styled.div`
  background: #ffffff;
  border: 1px solid #e1e7f2;
  border-radius: 16px;
  box-shadow: 0 10px 24px rgba(14, 41, 72, 0.06);
  padding: 2.6rem 1.5rem;
  text-align: center;
  font-family: Poppins;
  font-size: 0.9rem;
  color: ${(props) => props.$tone || '#5f7090'};
`

export const StateHint = styled.div`
  font-size: 0.8rem;
  color: #8795a8;
  margin-top: 0.45rem;
`
